export default __webpack_public_path__ + "static/3-b36757a2e4ace81c4610f8211a412edf.jpg";